import CountAnalytics from './count/CountAnalytics';
import DetectAnalytics from './detect/DetectionAnalytics';
import MonthlyDwellAnalytics from './dwellTime/MonthlyDwellChart';
import WeeklyDwellAnalytics from './dwellTime/WeeklyDwellChart';
import DailyDwellAnalytics from './dwellTime/DailyDwellChart';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import DwellAnalytics from './dwellTime/DwellAnalytics';
import NoDataUpgradePrompt from '../../NoData';
import PeopleOccupancyAnalytics from './PeopleOccupancy/PeopleOccupancyAnalytics';
import '../../../../styles/count_graphs.css'
import { url } from '../../../../api/endpointURL';
import { selectedBarBorderColor, barBackgroundColorLineCrossing, barBackgroundColorReverseLineCrossing } from '../../../../config/index';
import Tooltip from '../../../../ui-components/Tooltip/Tooltip';

const AnalyticsComponent = ({
  selectedSite,
  selectedCamera,
  selectedSuite,
  selectedYear,
  selectedCameraId = 'All',
  processedCameraData = []
}) => {

  const [isCountExpanded, setIsCountExpanded] = useState(true);
  const [isOccupancyExpanded, setIsOccupancyExpanded] = useState(true);
  const [isDwellExpanded, setIsDwellExpanded] = useState(true);

  const [hasCountData, setHasCountData] = useState(null);
  const [hasOccupancyData, setHasOccupancyData] = useState(null);
  const [hasDwellData, setHasDwellData] = useState(null);


  const prevCameraRef = useRef(selectedCameraId);
  const prevHwidRef = useRef(selectedSite.hwid);

  useEffect(() => {
    if (selectedCameraId !== prevCameraRef.current || selectedSite.hwid !== prevHwidRef.current) {
      setHasCountData(true);
      setHasOccupancyData(true);
      setHasDwellData(true);
      setIsCountExpanded(true);
      setIsOccupancyExpanded(true);
      setIsDwellExpanded(true);
      prevCameraRef.current = selectedCameraId;
      prevHwidRef.current = selectedSite.hwid;
    }
  }, [selectedCameraId, selectedSite.hwid]);

  const handleCountDataState = (hasData) => {
    setHasCountData(hasData);

    if (!hasData) {
      // console.log("No count data");
      setIsCountExpanded(true);
    }
  };

  const handleOccupancyDataState = (hasData) => {
    setHasOccupancyData(hasData);

    if (!hasData) {
      setIsOccupancyExpanded(false);
    }
  };

  const handleDwellDataState = (hasData) => {
    setHasDwellData(hasData);

    if (!hasData) {
      setIsDwellExpanded(false);
    }
  };

  return (
    <div className="graphs-container" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      {selectedSite && selectedCamera && selectedSuite && (
        <>
          {/* Count Analytics Section */}

          <div style={{ width: '90%', margin: '20px 0', textAlign: 'left', position: 'relative', cursor: 'pointer' }}
            onClick={() => setIsCountExpanded(!isCountExpanded)}>
            <div style={{
              display: 'inline-block', padding: '0 10px', background: '#2B3441', position: 'relative', zIndex: 1,
              boxShadow: `0px 5px 15px ${isCountExpanded ? 'rgba(255, 165, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'}`
            }}>
              <Tooltip content="People Count Analytics per month, week, day and hour, per camera" >
                <span style={{ fontSize: '1.2em', color: hasCountData ? 'white' : 'grey' }}>
                  Count Analytics {isCountExpanded ? '▲' : '▼'}
                </span>
              </Tooltip>
            </div>
            <div style={{
              position: 'absolute', top: '50%', left: '0', right: '0', height: '0px',
              background: '#2B3441', 
              boxShadow: `0px 5px 15px ${isCountExpanded ? 'rgba(255, 165, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'}`, 
              zIndex: 0
            }} />
          </div>
          {(isCountExpanded && (hasCountData === true || hasCountData === null)) && (
            <div style={{ width: '90%' }}>
              <CountAnalytics
                hwid={selectedSite?.hwid}
                site={selectedSite?.site}
                selectedCamera={selectedCamera}
                selectedCameraId={selectedCameraId}
                selectedYear={selectedYear}
                handleCountDataState={handleCountDataState}
                processedCameraData={processedCameraData}
              />
            </div>
          )}
          {isCountExpanded && hasCountData === false && (
            <div style={{ width: '90%' }}>
              <NoDataUpgradePrompt title="Count Analytics" />
            </div>
          )}

          {/* Detect Analytics Section */}

          <div style={{ width: '90%', margin: '20px 0', textAlign: 'left', position: 'relative', cursor: 'pointer' }}
            onClick={() => setIsOccupancyExpanded(!isOccupancyExpanded)}>
            <div style={{
              display: 'inline-block', padding: '0 10px', background: '#2B3441', position: 'relative', zIndex: 1,
              boxShadow: `0px 5px 15px ${isOccupancyExpanded ? 'rgba(255, 165, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'}`
            }}>
              <Tooltip content="Number of times occupancy threshold exceeded" >
                <span style={{ fontSize: '1.2em', color: hasOccupancyData ? 'white' : 'grey' }}>
                  People Occupancy Analytics {isOccupancyExpanded ? '▲' : '▼'}
                </span>
              </Tooltip>
            </div>
            <div style={{
              position: 'absolute', top: '50%', left: '0', right: '0', height: '0px',
              background: '#2B3441', 
              boxShadow: `0px 5px 15px ${isOccupancyExpanded ? 'rgba(255, 165, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'}`, 
              zIndex: 0
            }} />
          </div>

          {(isOccupancyExpanded && (hasOccupancyData === true || hasOccupancyData === null)) && (
            <div style={{ width: '90%' }}>
              <PeopleOccupancyAnalytics
                selectedSite={selectedSite}
                selectedCameraId={selectedCameraId}
                selectedYear={selectedYear}
                handleOccupancyDataState={handleOccupancyDataState}
              />

            </div>
          )}
          {isOccupancyExpanded && hasOccupancyData === false && (
            <div style={{ width: '90%' }}>
              <NoDataUpgradePrompt title="Occupancy Analytics" />
            </div>
          )}

          {/* Dwell Time Analytics Section */}

          <div style={{ width: '90%', margin: '20px 0', textAlign: 'left', position: 'relative', cursor: 'pointer' }}
            onClick={() => setIsDwellExpanded(!isDwellExpanded)}>
            <div style={{
              display: 'inline-block', padding: '0 10px', background: '#2B3441', position: 'relative', zIndex: 1,
              boxShadow: `0px 5px 15px ${isDwellExpanded ? 'rgba(255, 165, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'}`
            }}>
              <Tooltip content="Number of times loitering threshold exceeded">
                <span style={{ fontSize: '1.2em', color: hasDwellData ? 'white' : 'grey' }}>
                  Loitering Detection {isDwellExpanded ? '▲' : '▼'}
                </span>
              </Tooltip>
            </div>
            <div style={{
              position: 'absolute', top: '50%', left: '0', right: '0', height: '0px',
              background: '#2B3441', 
              boxShadow: `0px 5px 15px ${isDwellExpanded ? 'rgba(255, 165, 0, 0.2)' : 'rgba(255, 255, 255, 0.2)'}`, 
              zIndex: 0
            }} />
          </div>

          {(isDwellExpanded && (hasDwellData === true || hasDwellData === null)) && (
            <div style={{ width: '90%' }}>
              <DwellAnalytics
                selectedSite={selectedSite}
                selectedCamera={selectedCamera}
                selectedCameraId={selectedCameraId}
                selectedYear={selectedYear}
                handleDwellDataState={handleDwellDataState}
              />
            </div>
          )}
          {isDwellExpanded && hasDwellData === false && (
            <div style={{ width: '90%' }}>
              <NoDataUpgradePrompt title="Dwell Time Analytics" />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AnalyticsComponent;
